import Vue from 'vue'
import VueCookies from 'vue-cookies'
import api from '../../api/leadRealAPI'
import router from '../../router'

Vue.use(VueCookies)

export default {
  namespaced: true,

  state: {
    currentPlan: {
      name: null,
      price: null,
      currency: null,
      start_at: null,
      end_at: null,
      next_at: null,
      status: null,
      invoice_url: null
    },
    listing: {
      total_limit: null,
      option_limit: null,
      used: null
    },
    aiTranslating: {
      total_limit: null,
      option_limit: null
    },
    nextPlan: {
      name: null,
      price: null,
      currency: null,
      start_at: null,
      end_at: null,
      next_at: null,
      status: null
    },
    customerPortalUrl: null,
    listingOptionUrl: null,
    aiTranslatingOptionUrl: null,
    language: router.currentRoute.params.lang
  },

  getters: {
    currentPlan: state => state.currentPlan,
    listing: state => state.listing,
    aiTranslating: state => state.ai_translating,
    nextPlan: state => state.nextPlan,
    customerPortalUrl: state => state.customerPortalUrl,
    listingOptionUrl: state => state.listingOptionUrl,
    aiTranslatingOptionUrl: state => state.aiTranslatingOptionUrl
  },

  mutations: {
    setPlan (state, plan) {
      state.currentPlan = plan.current
      state.listing = plan.listing
      state.aiTranslating = plan.ai_translating
      state.nextPlan = plan.next
      state.customerPortalUrl = plan.customer_portal_url
      state.listingOptionUrl = plan.listing_option_url
      state.aiTranslatingOptionUrl = plan.ai_translating_option_url
    }
  },

  actions: {
    getPlan ({ commit }, data) {
      api
        .get('/member/plan', { params: data })
        .then(response => {
          commit('setPlan', response.data.data)
        })
        .catch(() => {})
    }
  }
}
